module.exports.colors = {
  'disabled-control-border': '#757575',
  'disabled-control-color': '#17191D',
  'eclipse-gray': '#393939',
  'internal-links-gray': '#393939',
  'light-silver': '#d8d8d8d',
  'light-alt': '#f2f2f2',
  'primary-contrast': 'var(--primary-contrast-color, var(--background-color, #ffffff))',
  'secondary-contrast': 'var(--secondary-contrast-color, var(--background-color, #ffffff))',
  'seo-footer-blue': '#153154',
  background: 'var(--background-color, #fff)',
  current: 'currentColor',
  dark: '#17191D',
  light: '#e2f2f7',
  link: 'var(--link-color, #4d6dd1)',
  platinum: '#E2E2E2',
  primary: 'var(--primary-color, #4d6dd1)',
  secondary: 'var(--secondary-color, #ef7f88)',
  text: 'var(--text-color, #000)',
  white: '#fff',
};
